import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom'
import Customer from './components/Customer';
import AuthProvider from './AuthProvider';
import Login from './components/Login';
import ProtectedRoute from './ProtectedRoute';
import Mypage from './components/MyPage';
import Report from './components/Report';
import NotFound from './components/NotFound';
import Home from './components/Home';
import Cms from './components/Cms';
import Surgery from './components/Surgery';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import Privacy from './components/Privacy'

function App() {
  
  return (
    <Router>
      <div className="App">
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />}/>
            <Route path="*" Component={NotFound} />
            <Route path="/watch_privacy" element={<Privacy/>}/>
            <Route element={<ProtectedRoute/>}>
              <Route path="/" element={<Home />} />
              <Route path="/surgery" element={<Surgery/>}/>
              <Route path="/customer" element={<Customer/>}/>
              <Route path="/mypage" element={<Mypage/>}/>
              <Route path="/report" element={<Report/>}/>
              <Route path="/cms" element={<Cms/>}/>
            </Route>
          </Routes>
        </AuthProvider>
      </div>
    </Router>
  );
}

export default App;
